// Daily-challenge reminder using the browser Notification API.
// This is a lightweight, tab-local scheduler (no service worker):
// while the page is open, if the user opted in and the UTC day has rolled
// over since their last daily play, we fire a notification once.

const OPTIN_KEY = "ppe_reminder_optin_v1";
const LAST_NOTIFIED_KEY = "ppe_reminder_last_v1";

export function reminderSupported() {
  return typeof window !== "undefined" && "Notification" in window;
}

export function reminderStatus() {
  if (!reminderSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export function reminderOptedIn() {
  try {
    return localStorage.getItem(OPTIN_KEY) === "1" && Notification.permission === "granted";
  } catch {
    return false;
  }
}

export async function optInReminder() {
  if (!reminderSupported()) return "unsupported";
  try {
    let perm = Notification.permission;
    if (perm === "default") {
      perm = await Notification.requestPermission();
    }
    if (perm === "granted") {
      localStorage.setItem(OPTIN_KEY, "1");
      return "granted";
    }
    return perm; // "denied"
  } catch {
    return "unsupported";
  }
}

export function optOutReminder() {
  try {
    localStorage.setItem(OPTIN_KEY, "0");
  } catch {}
}

// Fire the notification if the conditions are met (opted-in, new day, not
// already notified today, page open). Should be called on menu load.
export function maybeFireDailyReminder({ streak = 0 } = {}) {
  if (!reminderOptedIn()) return false;
  const today = new Date().toISOString().slice(0, 10);
  let last = null;
  try {
    last = localStorage.getItem(LAST_NOTIFIED_KEY);
  } catch {}
  if (last === today) return false;
  try {
    const body = streak > 0
      ? `Your streak is at ${streak} — keep it alive with today's challenge!`
      : "A fresh parking lot map is live. Can you beat everyone?";
    new Notification("Parking Plot Escape · Daily", {
      body,
      tag: "ppe-daily",
      icon: "/favicon.ico",
    });
    localStorage.setItem(LAST_NOTIFIED_KEY, today);
    return true;
  } catch {
    return false;
  }
}
